<template>
  <v-list
    three-line
  >
    <v-toolbar flat>
      <v-btn
        icon
        to="/training/list"
      >
        <v-icon>{{ mdiArrowLeft }}</v-icon>
      </v-btn>
      <v-toolbar-title>
        {{ $t('Workflow.Progress') }}
      </v-toolbar-title>
    </v-toolbar>
    <v-skeleton-loader
      v-if="!userRecords"
      type="list-item-avatar-three-line, divider, list-item-avatar-three-line"
    />
    <v-subheader v-if="userRecords">
      {{ $t('Training.TrainingApply') }}
    </v-subheader>
    <v-list-group
      v-for="(item) in userRecords"
      :key="item.formCode"
      no-action
    >
      <template
        v-slot:activator
      >
        <v-list-item-content>
          <v-list-item-title>{{ $chPtObjData('chinTaskListTitle', item) }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ $t('TaskList.Waiting') }}
            {{ $chPtObjData('chinStaffName', item.workflowStatusList[0]) }}
            ({{ momentWithHyphen(item.workflowStatusList[0].initiatedTime).format('YYYY-MM-DD HH:mm') }})
            {{ $chPtObjData('chinWorkflowStatusDesc', item.workflowStatusList[0]) }}
            <br>
            {{ $chPtObjData('chinTaskListDesc2', item) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <v-list-item>
        <v-list-item-subtitle class="grey--text">
          <div
            v-for="(status, index) in item.workflowStatusList"
            :key="status.workItemId"
          >
            <span
              v-if="index===0"
              class="black--text"
            >
              {{ $t('TaskList.Waiting') }} {{ $chPtObjData('chinStaffName', status) }} ({{ status.initiatedTime }}) {{ $chPtObjData('chinWorkflowStatusDesc', status) }}
            </span>
            <span v-else>
              {{ $chPtObjData('chinStaffName', status) }} ({{ status.initiatedTime }})
            </span>
          </div>
        </v-list-item-subtitle>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
import { mapState } from 'vuex'
// import store from '../../store'
import { staffModule, workflowModule } from '../../store/moduleName'
// import codeTable from '../../store/modules/hr/codeTable'
// import { dateToYyyyMmDd, addOrSubDays, formatDateTime } from '../../utils/datetimeUtil'
import { BUSINESS_CODE } from '../../constant/constant'
import workflowApi from '../../api/workflow/workflow'
import { mdiArrowLeft } from '@mdi/js'
// import { stat } from 'fs'

export default {
  components: {
  },
  data: function () {
    return {
      mdiArrowLeft: mdiArrowLeft,
      requestBody: [],
      userRecords: []
    }
  },
  computed: {
    ...mapState({
      staff: state => state[staffModule].info,
      business: state => state[workflowModule].items
    })
  },
  async created () {
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }

    this.requestBody[0] = BUSINESS_CODE.TRAINING
    await workflowApi.getPersonalActiveFormsWorkflowStatus(cb => {
      this.userRecords = cb.data
      this.userRecords.sort((a, b) => {
        return b.id - a.id
      })
    }, this.requestBody)

    this.userRecords.forEach(record => {
      record.workflowStatusList.reverse()
    })
  },
  methods: {
    search () {
      this.searchForm.entityId = this.staff.entityId
      workflowApi.searchForms(cb => {
        this.tableData = cb.data
        this.loading = false
      }, this.searchForm)
    }
  }
}
</script>
